export default __webpack_public_path__ + "static/media/uren-imac.ebf59936.png";